import moment from 'moment';

export const mappingBanners = (payload: any, filters: any): any => {
    const currentDate = moment();

    const ratingNumber = {
        date: 1,
        code: 5,
        travelType: 5,
    };

    const validItems1 = (payload || []).filter(function (item: any) {
        const { TravelType, StartDate, EndDate, FromCode, ToCode } = item.attributes;

        let travelTypeState = true;
        let StartDateState = true;
        let EndDateState = true;
        let CodeState = true;

        // travelType eşit değilse gösterme
        travelTypeState = filters.travelType === TravelType || TravelType === 'all' ? true : false;

        // StartDate henüz başlamadıysa gösterme
        if (StartDate) {
            StartDateState = moment(StartDate).diff(currentDate, 'seconds') < 0;
        }

        // EndDate geçtiyse gösterme
        if (EndDate) {
            EndDateState = moment(EndDate).diff(currentDate, 'seconds') > 0;
        }

        if (
            (FromCode && !FromCode.split(',')?.includes(filters.fromCode)) ||
            (ToCode && !ToCode.split(',')?.includes(filters.toCode))
        ) {
            CodeState = false;
        }

        return travelTypeState && StartDateState && EndDateState && CodeState;
    });

    const validItems2 = validItems1
        .map((item: any) => {
            let rating = 0;
            const { StartDate, EndDate, FromCode, ToCode, TravelType } = item.attributes;

            // Gidiş Tarihi
            if (StartDate && moment(StartDate).diff(currentDate, 'seconds') < 0) {
                rating += ratingNumber.date;
            }

            // Dönüş Tarihi
            if (EndDate && moment(EndDate).diff(currentDate, 'seconds') > 0) {
                rating += ratingNumber.date;
            }

            // From ve To Code Eşleşen
            if (filters.fromCode && FromCode && filters.toCode && ToCode) {
                if (FromCode.split(',')?.includes(filters.fromCode) && ToCode.split(',')?.includes(filters.toCode)) {
                    rating += ratingNumber.code;
                }
            } else {
                // From Code Eşleşen
                if (filters.fromCode && FromCode) {
                    if (FromCode.split(',')?.includes(filters.fromCode)) {
                        rating += ratingNumber.code;
                    }
                }

                // To Code Eşleşen
                if (filters.toCode && ToCode) {
                    if (ToCode.split(',')?.includes(filters.toCode)) {
                        rating += ratingNumber.code;
                    }
                }
            }

            // TravelType All Değilse
            if (TravelType !== 'all') {
                rating += ratingNumber.travelType;
            }

            return { ...item, rating };
        })

        .sort((a: any, b: any) => b.rating - a.rating);

    if (validItems2.length > 0) {
        const { Image, Url, ResponsiveImage } = validItems2[0].attributes;

        const newImage = Image?.data?.reduce((acc: any, image: any, index: number) => {
            acc[`banner${index + 1}`] = process.env.REACT_APP_STRAPI_BASE_URL + image.attributes.url;
            return acc;
        }, {});

        const newResponsiveImage = ResponsiveImage?.data?.reduce((acc: any, image: any, index: number) => {
            acc[`banner${index + 1}`] = process.env.REACT_APP_STRAPI_BASE_URL + image.attributes.url;
            return acc;
        }, {});

        const newData: any = {
            ID: validItems2[0].id,
            Url: Url,
            Image: newImage,
            ResponsiveImage: newResponsiveImage,
            rating: validItems2[0].rating,
        };

        return newData;
    }

    return null;
};

export const mappingHomeBanners = (payload: any, where?: any): any => {
    if (where === 'Support') {
        const { image, url, responsiveImage, id, isActive } = payload;
        const newImage = process.env.REACT_APP_STRAPI_BASE_URL + image?.data?.attributes.url;
        const newResponsiveImage = process.env.REACT_APP_STRAPI_BASE_URL + responsiveImage?.data?.attributes.url;

        if (isActive) {
            const newData: any = {
                ID: id,
                Url: url,
                Image: newImage,
                ResponsiveImage: newResponsiveImage,
            };
            return newData;
        }

        return null;
    } else {
        const validItems2 = payload || [];

        if (validItems2.length > 0) {
            const arr: any[] = [];
            validItems2.map((item: any) => {
                const { image, url, responsiveImage, name, id, isActive } = item;

                const newImage = process.env.REACT_APP_STRAPI_BASE_URL + image?.data?.attributes.url;
                const newResponsiveImage =
                    process.env.REACT_APP_STRAPI_BASE_URL + responsiveImage?.data?.attributes.url;

                const newData: any = {
                    ID: id,
                    Url: url,
                    Name: name,
                    Image: newImage,
                    ResponsiveImage: newResponsiveImage,
                };
                if (isActive) arr.push(newData);
            });

            return arr;
        }
        return [];
    }
};
